export default {
    methods: {
        uploadWx(url) {
            // 上传微信临时图片
            return this.$ajax.gatewayPost('/v1/kf/reception/receptionConf/wechatSvr/wxAccountImage/uploadImage', { img_url: url }).then((res) => {
                if (res.code === 0) {
                    return res.data.media_id;
                }
                this.$message.error(res.msg);
                return '';
            });
        },
    },
};
